import { z } from 'zod';

const FULL_NAME_PATTERN = /^[\p{L}\s'-]+$/u;
const COMPANY_NAME_PATTERN = /^[\p{L}\p{N}\s'&.,()/-]+$/u;
const UNSAFE_MARKUP_PATTERN = /<|>|javascript:/i;

const fullNameField = (minKey: string, maxKey: string, formatKey: string) =>
  z.string().trim().min(2, minKey).max(100, maxKey).regex(FULL_NAME_PATTERN, formatKey);

const companyNameField = (minKey: string, maxKey: string, formatKey: string) =>
  z
    .string()
    .trim()
    .min(2, minKey)
    .max(100, maxKey)
    .regex(COMPANY_NAME_PATTERN, formatKey)
    .refine((value) => !UNSAFE_MARKUP_PATTERN.test(value), formatKey);

export function createCompleteProfileSchema(requireCompanyName: boolean) {
  return z.object({
    fullName: fullNameField(
      'completeProfile.validation.fullNameMin',
      'completeProfile.validation.fullNameMax',
      'completeProfile.validation.fullNameFormat',
    ),
    companyName: requireCompanyName
      ? companyNameField(
          'completeProfile.validation.companyNameMin',
          'completeProfile.validation.companyNameMax',
          'completeProfile.validation.companyNameFormat',
        )
      : z
          .string()
          .trim()
          .max(100, 'completeProfile.validation.companyNameMax')
          .refine((value) => value === '' || !UNSAFE_MARKUP_PATTERN.test(value), {
            message: 'completeProfile.validation.companyNameFormat',
          })
          .refine((value) => value === '' || COMPANY_NAME_PATTERN.test(value), {
            message: 'completeProfile.validation.companyNameFormat',
          })
          .optional()
          .or(z.literal('')),
  });
}

export type CompleteProfileFormValues = z.infer<ReturnType<typeof createCompleteProfileSchema>>;
